import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DocsViewer from '../Documents/DocsViewer';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { DEFAULT_API_URL } from '../../constents';
import { useSelector } from 'react-redux';
function PatVisitRightSideBarRow({ data, handleReload }) {
  const { user } = useSelector((state) => state.auth);
  const [docsViewerOpen, setDocsViewerOpen] = useState(false);
  const [reviewPromt, setReviewPromt] = useState(false);
  const [docsId, setDocsId] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const handleViewerDocs = (docsId) => {
    setDocsId(docsId);
    setDocsViewerOpen(true);
  };

  const handleViewerClose = () => {
    setDocsId('');
    setDocsViewerOpen(false);
  };

  const removeDoc = (docsId) => {
    setReviewPromt(true);
    setSucPrams(docsId);
  };

  const handleRevertConfirm = async (docsId) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/deleteDocumentInfo',
        {
          loginUserId: user?.id,
          patientId: data?.patientId,
          docId: docsId,
          table: '0',
        }
      );
      if (response.status === 200) {
        setUiMessage('suc', response.data?.msg);
        setReviewPromt(false);
        handleReload();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const openIntakeReview = async (
    dob = '',
    intakeId = 0,
    userType = 1,
    formId = 0
  ) => {
    try {
      const response = await post(
        'api/patient/ManagePatientDocument/checkLogin',
        {
          intakeId: intakeId,
          dob: dob,
          userType: userType,
          formId: formId,
          loginUserId: user?.id,
        }
      );
      if (response.status === 200) {
        if (parseInt(response.data?.status) === 1) {
          let url;
          if (response.data?.formId !== '') {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/${response.data?.formId}/${response.data?.ch_external_link_key}`;
          } else {
            url = `${DEFAULT_API_URL}/registration/profile/index/${response.data?.patientId}/${response.data?.intakeId}/${response.data?.userType}/${response.data?.ch_external_link_key}`;
          }
          window.open(url, '_blank');
        } else if (parseInt(response.data?.status) === 0) {
          setUiMessage('err', 'Wrong User Credentials');
        } else if (parseInt(response.data?.status) === 2) {
          setUiMessage(
            'err',
            'Link has been expire.Please contact to adminstrator!'
          );
        } else if (response.data?.status === 3) {
          setUiMessage(
            'err',
            'Unable to access this portal as it is not filled by patient till now.Please contact to adminstrator!'
          );
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  return (
    <>
      <div className="chrt-doc-sec-nm flex-sec">
        {data.doc_name} [{data.status}]{/* Consult Notes [Reviewed] */}
      </div>
      <div className="chrt-doc-sec-dt flex-sec">
        <span className="sec-colr">
          Added by: {data.addedBy} [{data.doc_Date}]
        </span>
        {/* <span className="">Added by: M Kashif [07-05-2023]</span> */}
      </div>
      <div className="chrt-doc-sec-dt flex-sec">
        <span className="sec-colr">
          Reviewed by: {data.reviewedBy}{' '}
          {data.review_Date !== '' ? `[${data.review_Date}]` : null}
        </span>
        {/* <span className="">Reviewed by: M Kashif [07-05-2023]</span> */}
      </div>
      <div className="chrt-doc-sec-dt flex-sec">
        {(() => {
          if (parseInt(data?.intake_form_id)) {
            return (
              <Link
                onClick={() =>
                  openIntakeReview(
                    data?.dob,
                    data?.intake_id,
                    data?.userType,
                    data?.intake_form_id
                  )
                }
              >
                Access
              </Link>
            );
          } else {
            return (
              <span className="" onClick={() => handleViewerDocs(data.id)}>
                <Link className="">Preview</Link>
              </span>
            );
          }
        })()}

        <span
          className={`red clear-right clear-left10 ${
            data.status === 'Reviewed' ? 'hide ' : ''
          }`}
        >
          |
        </span>
        <span className={data.status === 'Reviewed' ? ' hide' : ''}>
          <Link className="" onClick={() => removeDoc(data?.id)}>
            Remove
          </Link>
        </span>
      </div>
      {docsViewerOpen && docsId && (
        <DocsViewer
          close={handleViewerClose}
          patientId={data?.patientId}
          docsId={docsId}
        />
      )}
      {reviewPromt && (
        <ConfirmDialog
          title={`Patient documents`}
          bodytext={`Do you really want to delete the selected document..?`}
          closeDialog={() => setReviewPromt(false)}
          successDialog={handleRevertConfirm}
          sucPrams={sucPrams}
        />
      )}
    </>
  );
}

export default PatVisitRightSideBarRow;
